import { render, staticRenderFns } from "./ClassView.vue?vue&type=template&id=cd1a3f70&scoped=true&"
import script from "./ClassView.vue?vue&type=script&lang=js&"
export * from "./ClassView.vue?vue&type=script&lang=js&"
import style0 from "./ClassView.vue?vue&type=style&index=0&id=cd1a3f70&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd1a3f70",
  null
  
)

export default component.exports